import { render, staticRenderFns } from "./desuLimitGoodClassifyAction.vue?vue&type=template&id=7a3f1e51&scoped=true"
import script from "./desuLimitGoodClassifyAction.vue?vue&type=script&lang=js"
export * from "./desuLimitGoodClassifyAction.vue?vue&type=script&lang=js"
import style0 from "./desuLimitGoodClassifyAction.vue?vue&type=style&index=0&id=7a3f1e51&prod&scoped=true&lang=css"
import style1 from "./desuLimitGoodClassifyAction.vue?vue&type=style&index=1&id=7a3f1e51&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3f1e51",
  null
  
)

export default component.exports